import React from 'react';
import { createPortal } from 'react-dom';
import { UseFloatingReturn } from '@floating-ui/react';
import classNames from 'classnames/bind';
import styles from './Tooltip.module.css';

interface TooltipProps {
  isOpen: boolean;
  content: string;
  tooltipId: string;
  refs: UseFloatingReturn['refs'];
  floatingStyles: React.CSSProperties;
  getFloatingProps: () => Record<string, unknown>;
}

export default function Tooltip({
  isOpen,
  content,
  tooltipId,
  refs,
  floatingStyles,
  getFloatingProps,
}: TooltipProps) {
  const cx = classNames.bind(styles);

  if (!isOpen) return null;

  return createPortal(
    <div
      id={tooltipId}
      className={cx('tooltip')}
      style={floatingStyles}
      ref={refs.setFloating}
      {...getFloatingProps()}
    >
      {content}
    </div>,
    document.body
  );
}
